import React, { useState } from "react";
import TabNav from "../../components/TabNav";

import "./incidentRegister.css";
import MainLayout from "layouts/MainLayout";

const tabs = [
  "Incident Information",
  "Evidence Files",
  "Reporter",
  "Suspect",
  "Victims",
  "Witnesses",
  "Exhibits",
  "Assigned to",
];

const IncidentRegister: React.FC = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <MainLayout>
      <div className="incidentRegistration max-w-screen-lg">
        <div className="incident-title">
          <span className="text-2xl font-semibold text-gray-700">
            ⚖ Incident Registration
          </span>
        </div>

        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === "Incident Information" ? (
          <p>Incident Information Tab</p>
        ) : activeTab === "Evidence Files" ? (
          <p>Evidence Files Tab </p>
        ) : activeTab === "Reporter" ? (
          <p>Reporter Tab </p>
        ) : activeTab === "Suspect" ? (
          <p>Suspect Tab </p>
        ) : activeTab === "Victims" ? (
          <p>Victims Tab </p>
        ) : activeTab === "Witnesses" ? (
          <p>Witnesses Tab </p>
        ) : activeTab === "Exhibits" ? (
          <p>Exhibits Tab </p>
        ) : activeTab === "Assigned to" ? (
          <p>Assigned To Tab </p>
        ) : null}
      </div>
    </MainLayout>
  );
};

export default IncidentRegister;

